<template>
  <v-flex xs12 text-xs-center>
    <v-flex x1></v-flex>
    <v-flex>
      <div v-if="field.fieldType == 'TOOGLE'" class="toggle-container">
        <div class="toggle-button-container">
          <toggle
            :value="toogleValue"
            @input="(value) => changeValue(value, field.model, section.name)"
          >
          </toggle>
        </div>
        <div class="toggle-label-container">
          <span>{{ field.label }}</span>
        </div>
      </div>

      <v-select
        v-if="field.fieldType == 'COMBO'"
        :items="getValuesSelect(field.values)"
        item-text="label"
        :value="getSelectValue(fieldSection)"
        @change="(v) => changeValue(v.id, field.model, section.name)"
        :label="field.label"
        return-object
      >
      </v-select>

      <v-text-field
        v-if="field.fieldType == 'INPUT' && field.dataType == 'string'"
        :label="field.label"
        @change="(v) => changeValue(v, field.model, section.name)"
        :value="field.value"
      >
      </v-text-field>

      <v-text-field
        v-if="field.fieldType == 'INPUT' && field.dataType == 'integer'"
        :label="field.label"
        :value="field.value"
        ref="input"
        @change="(v) => changeValue(v, field.model, section.name)"
        mask="################"
        return-masked-value
      >
      </v-text-field>
    </v-flex>
    <v-flex x1></v-flex>
  </v-flex>
</template>

<script>
import Toggle from "@components/Toggle.vue";

export default {
  components: {
    Toggle,
  },

  props: {
    field: {
      type: Object,
    },
    sectionValue: {
      type: Object,
    },
    section: {
      type: Object,
    },
  },

  data() {
    return {
      step: null,
      id: null,
      config: {},
      deviceName: null,
      fieldValue: null,
      sections: [
        {
          label: null,
          fields: [],
        },
      ],
    };
  },

  computed: {
    toogleValue() {
      const val = this.sectionValue[this.field.model];
      return val;
    },
  },

  methods: {
    changeValue(val, model, sectionName) {
      this.$emit("changeValue", val, model, sectionName);
    },
    getSelectValue(field) {
      let label = "";

      label = field.values[field.value];

      return { id: field.value, label: label };
    },
    getValuesSelect(values) {
      let valuesSelect = [];

      for (let value in values) {
        valuesSelect.push({ id: value, label: values[value] });
      }

      return valuesSelect;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  margin-top: 10px;
}

.toggle-container {
  display: flex;
  align-items: center;
}

.toggle-button-container {
  margin-right: 10px;
}

.flex {
  align-items: center;
  justify-content: space-between;
}

.ips-firewall {
  width: 100%;
  text-align: center;
}
</style>
